import Alpine from "alpinejs";
import A11yDialog from "a11y-dialog";

Alpine.data("annotationHighlights", () => ({
    dialog: null,

    init() {
        const modalContainer = document.getElementById('annotation-dialog');
        this.dialog = new A11yDialog(modalContainer);

        this.dialog.on('show', () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            document.body.style.setProperty('--scroll-y', `${scrollY}px`);
            document.body.classList.add('modal--open');
        });

        this.dialog.on('hide', () => {
            const scrollY = parseInt(document.body.style.getPropertyValue('--scroll-y') || '0');
            document.body.classList.remove('modal--open');
            window.scrollTo(0, scrollY);
        });

        const handler = this.clickHighlightEventHandler.bind(this);

        document.getElementById('transcript')
            .querySelectorAll('.c-highlightable-annotation')
            .forEach(item => {
                item.addEventListener('click', handler);
                item.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handler(event);
                    }
                });
            });
    },

    async clickHighlightEventHandler(event) {
        event.preventDefault();
        const { target } = event;

        if (!target.classList.contains('c-highlight')) {
            return;
        }

        const annotationId = target.getAttribute('data-annotation-id');

        try {
            const response = await fetch(`/annotations-content/${annotationId}/`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const modalContentTarget = document.getElementById('annotation-dialog-body');

            if (!modalContentTarget) {
                console.error('Modal content target not found');
                return;
            }

            modalContentTarget.innerHTML = await response.text();
            this.dialog.show();

        } catch (error) {
            console.error(error);
        }
    }
}));